//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';
import constant from '~/const';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      filters: {
        fromDate: '',
        toDate: '',
        requisite: '',
        status: undefined,
      },
      constant,
    };
  },

  created() {
    this.$emit('update');
  },

  computed: {
    ...mapState('tradersCallbacks', ['filterList']),

    statuses() {
      return [
        ...this.constant.traders.CALLBACKS_STATUS_LIST,
        {
          id: 3,
          caption: 'All',
        },
      ];
    },
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions('tradersCallbacks', ['setFilters']),
  },
};
